interface DebugPanelProps {
  chatId: string;
}

export function DebugPanel({ chatId }: DebugPanelProps) {
  return (
    <div className="flex items-center justify-center gap-2 mt-2 pb-2">
      <span className="text-[10px] font-mono uppercase tracking-wider text-primary/50">
        chat_id
      </span>
      <code className="text-[10px] font-mono text-foreground-subtle/70 select-all">
        {chatId}
      </code>
    </div>
  );
}
